import { ModalFooter } from '@workramp/ui';
import styled from 'styled-components';

export const StyledModalFooter = styled(ModalFooter)`
  border-top: 1px solid ${({ theme }) => theme.colors.on[100]};
`;
